import { BrowserRouter, NavLink, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { ContainerEnd, Spacer } from "@eatbetter/ui-shared";
import { TruthSetScreen, TruthSetScreenNav } from "../screens/TruthSetScreen";
import { View } from "react-native";
import { globalStyleConstants } from "@eatbetter/ui-shared";
import React from "react";
import { AdminIngredientScreen, AdminIngredientScreenNav } from "../screens/AdminIngredientScreen";
import { AdminRecipesScreen, AdminRecipesScreenEmptyNav, AdminRecipesScreenIdNav } from "../screens/AdminRecipesScreen";
import { AdminHomeScreen, AdminHomeScreenNav } from "../screens/AdminHomeScreen";
import { AdminRecipeEditScreen, AdminRecipeEditScreenNav } from "../screens/AdminRecipeEditScreen";
import { AdminStoreHtmlScreen, AdminStoreHtmlScreenNav } from "../screens/AdminStoreHtmlScreen";
import { AdminBooksScreen, AdminBooksScreenEmptyNav, AdminBooksScreenIdNav } from "../screens/AdminBooksScreen";
import { AdminBookAddRecipeScreen, AdminRecipeAddBookScreenNav } from "../screens/AdminBookAddRecipeScreen";
import { AdminBookEditScreen, AdminBookEditScreenNav } from "../screens/AdminBookEditScreen";
import { AdminBookCreateScreen, AdminBookCreateScreenNav } from "../screens/AdminBookCreateScreen";
import { Select, Switch } from "antd";
import { useDispatch } from "../lib/AdminRedux";
import { setTheme } from "../lib/system/AdminSystemSlice";
import { AdminUsersScreen, AdminUsersScreenEmptyNav, AdminUsersScreenIdNav } from "../screens/AdminUsersScreen";
import { AdminUserRecipesScreen, AdminUserRecipesScreenNav } from "../screens/AdminUserRecipesScreen";
import { ParsedItemDebugScreen, ParsedItemDebugScreenNav } from "../screens/ParsedItemDebugScreen";
import { AdminRecipeOrphanScreen, AdminRecipeOrphanScreenNav } from "../screens/AdminRecipeOrphanScreen";
import { AdminUserSocialScreen, AdminUserSocialScreenNav } from "../screens/AdminUserSocialScreen";
import { AdminRecipeDocumentsScreen, AdminRecipeDocumentsScreenNav } from "../screens/AdminRecipeDocumentsScreen";
import { AdminKnownDataScreen, AdminKnownDataScreenNav } from "../screens/AdminKnownDataScreen";
import { AdminServiceStatusScreen, AdminServiceStatusScreenNav } from "../screens/AdminServiceStatusScreen";

export const isLocalHost = () => window.location.hostname.endsWith("localhost");

export const AdminNav = () => {
  return (
    <BrowserRouter>
      <NavHeader />
      <Routes>
        <Route path={AdminHomeScreenNav.getPath()} element={<AdminHomeScreen />} />
        <Route path={AdminRecipesScreenEmptyNav.getPath()} element={<AdminRecipesScreen />} />
        <Route path={AdminRecipesScreenIdNav.getPath()} element={<AdminRecipesScreen />} />
        <Route path={AdminRecipeEditScreenNav.getPath()} element={<AdminRecipeEditScreen />} />
        <Route path={AdminRecipeOrphanScreenNav.getPath()} element={<AdminRecipeOrphanScreen />} />
        <Route path={AdminRecipeDocumentsScreenNav.getPath()} element={<AdminRecipeDocumentsScreen />} />
        <Route path={AdminIngredientScreenNav.getPath()} element={<AdminIngredientScreen />} />
        <Route path={TruthSetScreenNav.getPath()} element={<TruthSetScreen />} />
        <Route path={ParsedItemDebugScreenNav.getPath()} element={<ParsedItemDebugScreen />} />
        <Route path={AdminStoreHtmlScreenNav.getPath()} element={<AdminStoreHtmlScreen />} />
        <Route path={AdminBooksScreenEmptyNav.getPath()} element={<AdminBooksScreen />} />
        <Route path={AdminBooksScreenIdNav.getPath()} element={<AdminBooksScreen />} />
        <Route path={AdminRecipeAddBookScreenNav.getPath()} element={<AdminBookAddRecipeScreen />} />
        <Route path={AdminBookEditScreenNav.getPath()} element={<AdminBookEditScreen />} />
        <Route path={AdminBookCreateScreenNav.getPath()} element={<AdminBookCreateScreen />} />
        <Route path={AdminUsersScreenEmptyNav.getPath()} element={<AdminUsersScreen />} />
        <Route path={AdminUsersScreenIdNav.getPath()} element={<AdminUsersScreen />} />
        <Route path={AdminUserRecipesScreenNav.getPath()} element={<AdminUserRecipesScreen />} />
        <Route path={AdminUserSocialScreenNav.getPath()} element={<AdminUserSocialScreen />} />
        <Route path={AdminKnownDataScreenNav.getPath()} element={<AdminKnownDataScreen />} />
        <Route path={AdminServiceStatusScreenNav.getPath()} element={<AdminServiceStatusScreen />} />
      </Routes>
    </BrowserRouter>
  );
};

const navItems = [
  { label: "Home", path: AdminHomeScreenNav.getPath() },
  { label: "Users", path: AdminUsersScreenEmptyNav.getPath() },
  { label: "Recipes", path: AdminRecipesScreenEmptyNav.getPath() },
  { label: "Known Data", path: AdminKnownDataScreenNav.getPath() },
  { label: "Books", path: AdminBooksScreenEmptyNav.getPath() },
  { label: "Truth", path: TruthSetScreenNav.getPath() },
  { label: "Ingredients", path: AdminIngredientScreenNav.getPath() },
  { label: "Service Status", path: AdminServiceStatusScreenNav.getPath() },
];

const narrowBreakpoint = 768;

export const NavHeader = React.memo(() => {
  const dispatch = useDispatch();
  const onToggleTheme = (light: boolean) => {
    dispatch(setTheme(light ? "light" : "dark"));
  };

  const [isNarrow, setIsNarrow] = React.useState(() => window.innerWidth < narrowBreakpoint);

  React.useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${narrowBreakpoint - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
        padding: 2 * globalStyleConstants.unitSize,
        backgroundColor: "lightGrey",
      }}
    >
      {isNarrow ? <NavDropdown /> : <NavLinks />}
      <ContainerEnd horizontal>
        <Switch checkedChildren="Light" unCheckedChildren="Dark" defaultChecked onChange={onToggleTheme} />
      </ContainerEnd>
    </View>
  );
});

const NavLinks = () => {
  return (
    <>
      {navItems.map((item, i) => (
        <React.Fragment key={item.path}>
          {i > 0 && <Spacer horizontal={1} />}
          <NavLink to={item.path} style={navLinkStyle}>
            {item.label}
          </NavLink>
        </React.Fragment>
      ))}
    </>
  );
};

const NavDropdown = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Select
      value={location.pathname}
      onChange={(path: string) => navigate(path)}
      style={{ minWidth: 160 }}
      options={navItems.map(item => ({ label: item.label, value: item.path }))}
    />
  );
};

const navLinkStyle = (i: { isActive: boolean }) => {
  const base = {
    textDecoration: "none",
  };
  const fontWeight = i.isActive ? 900 : 500;
  const color = i.isActive ? "red" : "black";
  return { ...base, fontWeight, color };
};
